// This script waits for the page to fully load before running to ensure 
// all HTML elements, especially the canvas, are available.
document.addEventListener('DOMContentLoaded', function() {
    
    // Find the canvas element on the page.
    const canvas = document.getElementById('halftone-canvas');
    
    // IMPORTANT: If the canvas element doesn't exist on the current page,
    // stop the script to prevent errors.
    if (!canvas) {
        return;
    }

    const ctx = canvas.getContext('2d');

    // --- Configuration ---
    const darkBrown = '#17110a';    // This is the DOT color
    const mediumBrown = '#21190f';  // This is the BACKGROUND color
    const dotSpacing = 11.25; // Decreased for more, closer dots
    const maxDotSize = 6;  // Decreased for smaller dots
    const minDotSize = 0.2;  // Decreased for smaller dots
    const noiseAmount = 10000; // Increased for more grain.
    const scratchCount = 3;  // Decreased for fewer scratches.

    /**
     * Draws the entire halftone pattern on the canvas.
     * This function is called on initial load and on window resize.
     */
    function drawHalftone() {
        // Set the canvas dimensions to fill the entire browser window.
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // Fill background with the base MEDIUM brown color
        ctx.fillStyle = mediumBrown;
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // --- Draw background blotches for a distressed look ---



        // --- Apply Rotation ---
        // Save the default state of the canvas before transforming it.
        ctx.save();
        // 1. Move the canvas origin to the center for proper rotation.
        ctx.translate(canvas.width / 2, canvas.height / 2);
        // 2. Rotate the entire canvas context by 25 degrees.
        ctx.rotate(-10 * Math.PI / 180);
        // 3. Move the origin back to the top-left corner.
        ctx.translate(-canvas.width / 2, -canvas.height / 2);

        // Draw dots with the DARK brown color
        ctx.fillStyle = darkBrown;

        // To ensure the rotated canvas covers the whole screen, we must draw on a larger area.
        const offset = Math.max(canvas.width, canvas.height) * 0.3; // 30% larger area is safe

        // Loop through each row on the new, larger drawing area
        for (let y = -offset; y < canvas.height + offset; y += dotSpacing) {
            // Determine if the current row index is odd
            const isOddRow = (Math.floor(y / dotSpacing)) % 2 !== 0;

            // Loop through each column in the row
            for (let x = -offset; x < canvas.width + offset; x += dotSpacing) {
                let drawX = x;
                // If the row is odd, offset the dot's x-position
                if (isOddRow) {
                    drawX += dotSpacing / 2;
                }
                
                // This calculation creates a diagonal gradient from top-left to bottom-right.
                const diagonalValue = (drawX + y) / (canvas.width + canvas.height);
                const clampedValue = Math.max(0, Math.min(diagonalValue, 1.0)); // Ensure value is between 0 and 1
                const gradientValue = Math.pow(clampedValue, 1.5);
                const radius = maxDotSize - (gradientValue * (maxDotSize - minDotSize));

                if (radius > 0) {
                    ctx.beginPath();
                    ctx.arc(drawX, y, radius, 0, 2 * Math.PI, false);
                    ctx.fill();
                }
            }
        }

        // Restore the canvas to its original, un-rotated state.
        ctx.restore();

        // --- Apply Distressed Texture ---
        // This is drawn after the rotation is restored so the texture is not rotated.
        
        // 1. Draw Noise (fine grain)
        ctx.fillStyle = 'rgba(255, 255, 255, 0.08)'; // Subtle white noise for better contrast
        for (let i = 0; i < noiseAmount; i++) {
            const x = Math.random() * canvas.width;
            const y = Math.random() * canvas.height;
            ctx.fillRect(x, y, 1, 1);
        }

        // 2. Draw Scratches
        ctx.strokeStyle = 'rgba(255, 171, 27, 0.03)'; // Very subtle brown scratches
        ctx.lineCap = 'round'; // This makes the ends of the scratches rounded.
        const maxScratchLength = canvas.width / 4; // Set max length to 1/4 of screen width

        for (let i = 0; i < scratchCount; i++) {
            const startX = Math.random() * canvas.width;
            const startY = Math.random() * canvas.height;
            const angle = Math.random() * 2 * Math.PI;
            const length = Math.random() * maxScratchLength;
            
            // Draw multiple segments for each scratch to vary thickness
            for (let j = 0; j < 5; j++) {
                const segmentLength = length / 5;
                const prevX = startX + Math.cos(angle) * (segmentLength * j);
                const prevY = startY + Math.sin(angle) * (segmentLength * j);
                const currentX = startX + Math.cos(angle) * (segmentLength * (j + 1));
                const currentY = startY + Math.sin(angle) * (segmentLength * (j + 1));

                // Add a slight wobble to the path
                const wobbleX = (Math.random() - 0.5) * 10;
                const wobbleY = (Math.random() - 0.5) * 10;
                
                // Set a random thickness for each segment
                ctx.lineWidth = Math.random() * 12 + 2;

                ctx.beginPath();
                ctx.moveTo(prevX + wobbleX, prevY + wobbleY);
                ctx.lineTo(currentX + wobbleX, currentY + wobbleY);
                ctx.stroke();
            }
        }
    }

// --- Event Listener for window resize ---
// Only add the resize listener on larger screens (desktops) to prevent
// glitching on mobile when the address bar appears/disappears.
if (window.innerWidth > 768) {
  let resizeTimeout;
  window.addEventListener('resize', () => {
    // Use a timeout to prevent the function from firing too often while resizing,
    // which improves performance.
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(drawHalftone, 100);
  });
}

    // --- Initial Draw ---
    // Draw the pattern for the first time when the script loads.
    drawHalftone();
});
